import { getRequiredMessage } from '@monetize/types/common';
import { z } from 'zod';
import { StorageSchema } from './storage.types';
export enum ReferenceResourceTypeEnum {
  FILE = 'FILE',
}
export const ReferenceResourceTypeEnumZ = z.enum([
  ReferenceResourceTypeEnum.FILE,
]);

export enum ReferenceResourceCategoryEnum {
  DEAL_ROOM = 'DEAL_ROOM',
}
export const ReferenceCategoryEnumZ = z.enum([
  ReferenceResourceCategoryEnum.DEAL_ROOM,
]);

export const ReferenceResourceSchema = z.object({
  id: z.string(),
  description: z
    .string()
    .max(255, 'Description must be less than 255 characters')
    .nullish()
    .transform((val) => (val ? val.trim() : val)),
  name: z
    .string()
    .min(1, getRequiredMessage('Name'))
    .max(255, 'Name must be less than 255 characters')
    .transform((val) => (val ? val.trim() : val)),
  resourceType: ReferenceResourceTypeEnumZ,
  category: ReferenceCategoryEnumZ,
  resourceContent: z.object({
    storageObjectId: z.string().nullish(),
    storageObject: StorageSchema.nullish(),
  }),
  isLocked: z.boolean(),
});

export type ReferenceResource = z.infer<typeof ReferenceResourceSchema>;
